"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickRandomGender = void 0;
const domain_1 = require("../domain");
const pickRandomGender = () => {
    return Math.random() < 0.5 ? domain_1.Gender.Male : domain_1.Gender.Female;
};
exports.pickRandomGender = pickRandomGender;
//# sourceMappingURL=pickRandomGender.js.map